// Utility to resolve the backend server URL at runtime.
// Simple and reliable: just check the hostname and use appropriate URL

const PROD_BACKEND_URL = 'https://tchat-server-kwjpvr5t7q-uc.a.run.app';

export function resolveServerUrl() {
	console.log('🔍 resolveServerUrl called');
	console.log('Environment:', process.env.NODE_ENV);
	console.log('REACT_APP_SERVER_URL:', process.env.REACT_APP_SERVER_URL);

	// First priority: explicit environment variable
	if (process.env.REACT_APP_SERVER_URL) {
		console.log('✅ Using REACT_APP_SERVER_URL:', process.env.REACT_APP_SERVER_URL);
		return process.env.REACT_APP_SERVER_URL;
	}

	// Auto-detect environment based on hostname
	if (typeof window !== 'undefined') {
		const isNative = !!(window.Capacitor && typeof window.Capacitor.getPlatform === 'function' && window.Capacitor.getPlatform() !== 'web');
		if (isNative) {
			// Prefer explicit native override if provided
			if (process.env.REACT_APP_SERVER_URL_NATIVE) {
				console.log('✅ Using REACT_APP_SERVER_URL_NATIVE:', process.env.REACT_APP_SERVER_URL_NATIVE);
				return process.env.REACT_APP_SERVER_URL_NATIVE;
			}

			// Default to production backend for native builds
			console.log('✅ Native runtime detected, defaulting to Cloud Run backend');
			return PROD_BACKEND_URL;
		}

		const { hostname } = window.location;
		console.log('🔍 Window hostname:', hostname);

		// Localhost development
		if (hostname === 'localhost' || hostname === '127.0.0.1') {
			console.log('✅ Detected localhost, using localhost:3001');
			return 'http://localhost:3001';
		}

		// Production Firebase Hosting -> Cloud Run backend
		if (hostname.includes('tchat-99f76.web.app') || hostname.includes('tchat-99f76.firebaseapp.com')) {
			console.log('✅ Detected Firebase Hosting, using Cloud Run backend');
			return PROD_BACKEND_URL;
		}

		// Any other hostname (custom domains) should also hit the Cloud Run backend.
		// The frontend is static-only on Firebase Hosting, so same-origin would 404.
		console.log('✅ Custom/non-local host detected, defaulting to Cloud Run backend');
		return PROD_BACKEND_URL;
	}

	// Fallback for SSR or other environments
	console.log('❌ Fallback to localhost:3001');
	return 'http://localhost:3001';
}

export default resolveServerUrl;


